/*
 * @Author: your name
 * @Date: 2021-05-17 14:44:35
 * @LastEditTime: 2022-12-07 18:03:57
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\buildingConfig\router.js
 */
const routes = [{
  path: '/building',
  name: 'building',
  // component: () => import('./pages/drawConfig'),
  component: () => import('./pages/Home'),
  redirect: '/building/index',
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: 'index',
      name: 'buildingIndex',
      component: () => import('./pages/buildingManage'),
      meta: {
        requireAuth: true,
        routerAlive: true,
        module: "building"
      }
    },
    {
      path: 'floorM',
      name: 'floorM',
      component: () => import('./pages/floorManage'),
      meta: {
        requireAuth: true,
        routerAlive: true,
        module: "building"
      }
    }
  ]
}]

export default routes